import { gql } from "@apollo/client";

export default gql`
  query getChangelogWhatsAppAccounts{
    getChangelogWhatsAppAccounts{
        success
        data
        error
        message
    }
}
`
